module.exports = __webpack_public_path__ + "static/media/wbnb2b_domain_brand_B2B_Indonesia.b25fceff.svg";